import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Edit from '@material-ui/icons/Edit';
import Loading from '../loading/loading';
import moment from "moment";
import FloatingActionButton from "../elements/floatingActionButton";
import {TABLE_VIEW_AMOUNTS} from "../../helpers/constants";
import CustomModal from "../elements/customModal";
import CriteriaFilterForm from './criteriaFilterForm';
import FilterListIcon from '@material-ui/icons/FilterList';
import ClearAll from '@material-ui/icons/ClearAll';
import Snackbar from "@material-ui/core/Snackbar";
import MySnackBarContent from '../elements/mySnackBarContent'
import Button from "@material-ui/core/Button/Button";
import TableSortLabel from '@material-ui/core/TableSortLabel';
import _ from 'lodash';
import MediaQuery from 'react-responsive';
import CriteriaListMobileView from './criteriaListMobileView';
import {scrollToElement} from "../../helpers/functions";

const columnData = [
  { id: 'id', numeric: false, disablePadding: false, label: 'Id' },
  { id: 'code', numeric: false, disablePadding: false, label: 'Code' },
  { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
  { id: 'weightOld', numeric: false, disablePadding: false, label: 'Εξάμηνη βαρύτητα' },
  { id: 'weightNew', numeric: false, disablePadding: false, label: 'Βαρύτητα νέων καταστημάτων' },
  { id: 'weightNewComing', numeric: false, disablePadding: false, label: 'Βαρύτητα υφιστάμενων καταστημάτων' },
  { id: 'category', numeric: false, disablePadding: false, label: 'Category' },
  { id: 'department', numeric: false, disablePadding: false, label: 'Department' },
  { id: 'pillar', numeric: false, disablePadding: false, label: 'Pylon' },
  { id: 'createdDate', numeric: false, disablePadding: false, label: 'Created Date' },
];

class EnhancedTableHead extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, numSelected, rowCount, order, orderBy} = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell />
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  spacer: {
    flex: '1 1 auto',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  '@media screen and (max-width: 768px)': {
    root: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            Criteria
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton aria-label="Delete">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : <div>
          <Button color="secondary" className={classes.button} onClick={props.clearFilters}>
            Clear filters
            <ClearAll  className={'ml-1'}/>
          </Button>
          <Button color="primary" className={classes.button} onClick={props.openFilterModal}>
            Filter list
            <FilterListIcon className={'ml-1'}/>
          </Button>
        </div>}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  '@media screen and (max-width: 768px)': {
    pager: {
      paddingBottom: '8% !important',
    },
    pagerToolbar: {
      flexWrap: 'wrap !important',
      justifyContent: 'center !important'
    }
  }
});

class Criteria extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: 'desc',
      orderBy: 'createdDate',
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 100,
      filterModalOpen: false,
      deleteModalOpen: false,
      criterionId: null
    };

    this.criteriaListRef = React.createRef();

  }

  _changeLocalState = (payload) => {
    this.setState({
      ...this.state,
      [payload.key]: payload.value
    })
  };

  _openDeleteModal = (criterionId) => {
    this.setState({
      ...this.state,
      deleteModalOpen: true,
      criterionId: criterionId
    })
  };

  _closeDeleteModal = () => {
    this.setState({
      ...this.state,
      deleteModalOpen: false,
      criterionId: null
    })
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.props.criteria.map(n => n.id) });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  filterCriteria = (formIM) => {
    const weight = formIM.get('weight');
    const whereAndFilter = [
      {or: [{deleted: false}, {deleted: null}]},
      {departmentId: formIM.get('departmentId')},
      {categoryId: formIM.get('categoryId')}
    ];
    if(formIM.get('name')){
      whereAndFilter.push({name : {like: `%25${formIM.get('name')}%25`}})
    }
    if(formIM.get('code')){
      whereAndFilter.push({code: formIM.get('code')})
    }
    if(weight === 'new'){
      whereAndFilter.push({weightNew: {gt: 0}})
    }
    if(weight === 'newComing'){
      whereAndFilter.push({weightNewComing: {gt: 0}})
    }
    if(weight === 'old'){
      whereAndFilter.push({weightOld: {gt: 0}})
    }
    this.props.getCriteriaWithFilters({filter: {
        include: [{relation: 'category', scope: {include: 'pillar'}}, 'department'],
        where: {and: whereAndFilter}
      }});
    this.closeFilterModal();
  };

  clearFilters = () => {
    this.props.getCriteria({filter: {
        include: [{relation: 'category', scope: {include: 'pillar'}}, 'department'],
        where: {or: [{deleted: false}, {deleted: null}]}
      }
    });
  };

  openFilterModal = () => {
    this.setState({ filterModalOpen: true });
  };

  closeFilterModal = () => {
    this.setState({ filterModalOpen: false });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  render() {
    const { classes } = this.props;
    const { selected, rowsPerPage, page, order, orderBy } = this.state;
    const data = this.props.criteria;

    return (
      <div>
        <CustomModal
          open={this.state.deleteModalOpen}
          handleClose={this._closeDeleteModal}
          content={<div>
            <Loading displayLoader={this.props.deletingCriterion}/>
            <div className={'col-12'}>{'Are you sure you want to delete the selected criterion?'}</div>
            <div className={'col-12 mt-3'}>
              <Button
                onClick={() => this.props.deleteCriterion({id: this.state.criterionId})}
                variant="contained"
                color="primary"
                className={'mr-3'}
              >
                {'Yes'}
              </Button>
              <Button onClick={this._closeDeleteModal} variant="contained" color="secondary">
                {'No'}
              </Button>
            </div>
          </div>}
        />
        <CustomModal
          open={this.state.filterModalOpen}
          handleClose={this.closeFilterModal}
          content={<CriteriaFilterForm {...this.props} filterCriteria={this.filterCriteria} handleCancel={this.closeFilterModal}/>}
        />
        <Loading displayLoader={this.props.loading}/>
        <MediaQuery query="(max-device-width: 768px)">
          <CriteriaListMobileView
            {...this.props}
            classes={null}
            clearFilters={this.clearFilters}
            openFilterModal={this.openFilterModal}
            _closeDeleteModal={this._closeDeleteModal}
            _openDeleteModal={this._openDeleteModal}
            filterCriteria={this.filterCriteria}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            page={page}
            _changeLocalState={this._changeLocalState}
            rowsPerPage={rowsPerPage}
          />
        </MediaQuery>
        <MediaQuery query="(min-device-width: 769px)">
          <div ref={this.criteriaListRef}>
            <Paper className={classes.root}>
              <EnhancedTableToolbar
                {...this.props}
                numSelected={selected.length}
                classes={null}
                openFilterModal={this.openFilterModal}
                clearFilters={this.clearFilters}
              />
              <div className={classes.tableWrapper}>
                <Table className={classes.table + ' table-sm compact'} aria-labelledby="tableTitle">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={this.handleSelectAllClick}
                    onRequestSort={this.handleRequestSort}
                    rowCount={data.length}
                  />
                  <TableBody>
                    {
                      _.orderBy(data, item => {
                        if(orderBy === 'category') {return item.category.name}
                        if(orderBy === 'department') {return item.department.name}
                        if(orderBy === 'pillar') {return item.category.pillar.name}
                        return item[orderBy]
                      }, order)
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                        const isSelected = this.isSelected(n.id);
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={isSelected}
                            tabIndex={-1}
                            key={n.id}
                            selected={isSelected}
                          >
                            <TableCell padding="checkbox">
                              <IconButton
                                aria-label="Edit criterion"
                                onClick={() => this.props.history.push('/criterion/' + n.id)}>
                                <Edit/>
                              </IconButton>
                              <IconButton
                                aria-label="Delete"
                                onClick={() => this._openDeleteModal(n.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                            <TableCell>
                              {n.id}
                            </TableCell>
                            <TableCell>
                              {n.code}
                            </TableCell>
                            <TableCell>
                              {n.name}
                            </TableCell>
                            <TableCell >
                              {n.weightOld}
                            </TableCell>
                            <TableCell>
                              {n.weightNew}
                            </TableCell>
                            <TableCell>
                              {n.weightNewComing}
                            </TableCell>
                            <TableCell>
                              {n.category.name}
                            </TableCell>
                            <TableCell>
                              {n.department.name}
                            </TableCell>
                            <TableCell>
                              {n.category.pillar.name}
                            </TableCell>
                            <TableCell>
                              {moment(n.createdDate).format('DD/MM/YYYY HH:mm:ss')}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                classes={
                  {
                    root: classes.pager,
                    toolbar: classes.pagerToolbar
                  }
                }
                rowsPerPageOptions={TABLE_VIEW_AMOUNTS}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'Next Page',
                }}
                onChangePage={(evt, page) => {
                  scrollToElement(this.criteriaListRef.current);
                  this.handleChangePage(evt, page);
                }}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </MediaQuery>
        <FloatingActionButton onClick={() => this.props.history.push('/criterion')}/>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={this.props.criteriaErrors.length > 0}
          onClose={() => { this.props.changeCriteriaState({key: 'errors', value: []}) }}
          ContentProps={{'aria-describedby': 'message-id',}}
        >
          <MySnackBarContent
            variant={'error'}
            message={
              <ul id="message-id">
                {this.props.criteriaErrors.map((item, index) => {return <li key={index}>{item}</li>})}
              </ul>
            }
          />
        </Snackbar>
      </div>
    );
  }
}

Criteria.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Criteria);



// WEBPACK FOOTER //
// ./src/components/criteria/criteria.js